import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfirmationDialogComponent } from "@app/pages/authenticated/components/confirmation-dialog/confirmation-dialog.component";

@Injectable({ providedIn: 'root' })
export class PPUAlertService {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

  public successEvent(message: string) {
    this.snackBar.open(message, '', {
        panelClass: 'success',
        duration: 3000,
        verticalPosition: 'top'            
      });
  }

  public errorEvent(message: string) {
    this.snackBar.open(message, '', {
        panelClass: 'error',
        duration: 5000,
        verticalPosition: 'top'            
      });
  }

  public confirmationDialog(message: string, confirmButton: string =  "Confirm", cancelButton: string =  "Cancel") {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: message,
        confirmButton: confirmButton,
        cancelButton: cancelButton
      },
      panelClass: "confirmation-dialog"
    });

    return dialogRef.afterClosed();
  }

  public alertDialog(message: string, confirmButton: string =  "Close") {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: message,
        confirmButton: confirmButton
      },
      panelClass: "confirmation-dialog"
    });

    return dialogRef.afterClosed();
  }
}
